<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="分类名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.className" placeholder="请输入单位名称">
						</el-input>
					</el-form-item>
                     <el-form-item label="是否展示" class='tiny'>
						<el-select v-model="orderInfo.isShow" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="不展示" :value="0"></el-option>
							<el-option :key="1" label="展示" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
		<!-- 	<el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="className" label="分类名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="image" label="图片" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.image" :src="scope.row.image" style="width: 50px;height: 50px;border-radius: 10px;" />
                    <div v-else>暂无图标</div>
                </template>
			</el-table-column>
			<el-table-column prop="orderIndex" label="排序" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="isShow" label="是否展示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.isShow==true" style="color: green;">展示</span>
					<span v-if="scope.row.isShow==false" style="color: red;">不展示</span>

				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 新增、编辑 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="popupType" @close="addDialogClose" width="40%"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="分类名称" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.className"
							auto-complete="off" placeholder="请输入单位名称" />
					</el-form-item>
					<el-form-item label="排序" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.orderIndex"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;
                            <!-- <span >
								数值越大，排序越靠前
							</span> -->
					</el-form-item>
					<el-form-item label="是否启用" label-width="100px">
						<el-switch v-model="storeGoodsInfo.isShow" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
                    <el-form-item label="分类图标" label-width="100px">
						<el-upload class="upload-demo" :action="imgUrl" :show-file-list="false"
							:on-success="onSuccess" :on-remove="handleRemove" :limit="1"
							:on-exceed="handleExceed" :file-list="fileList">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item label="图标" label-width="100px">
						<img v-if="Images" :src="Images" width="100px" hegiht="100px" />
						<div v-else>请上传图片</div>
					</el-form-item>

					<el-button v-if="popupType == '添加'" type="primary" @click="submit" :loading="loadingTJ">提交</el-button>
                    <el-button v-if="popupType == '编辑'" type="primary" @click="submitClick" :loading="loadingXG">提交</el-button>
                    <el-button @click="dialogVisibleSwiper=false">关闭</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
    import {
		uploadFile
    } from "@/api/axios.js";
    var urls = uploadFile();

	export default {
		data() {
			return {
                imgUrl: urls+'?type=classify',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				orderInfo: {},
				sliderlist:{},
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
                fileList: [],
                popupType: "",
                Images: '',
                loadingTJ: false,
                loadingXG: false
			}
		},
		methods: {
            handleRemove(file, fileList) {
				if (file.response) {
					this.Images.remove(file.response.message);
				}
				this.Images.remove(file.url);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log('图片',response);
                this.Images = response.message
			},
			search() { //查询
				this.page.pageNum = 1;
				this.getClassify()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			getClassify() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
                    className: this.orderInfo.className,
                    isShow:  this.orderInfo.isShow
				}
				this.$api.getProductList(data).then((res) => {
					// console.log('主营分类---',res.data.list)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
                this.popupType = '添加';
                this.Images = "";
                this.storeGoodsInfo= {};
				this.dialogVisibleSwiper = true
			},

			// 提交
			submit() {
                this.loadingTJ = true;
                let data={
                    className: this.storeGoodsInfo.className,
                    isShow: this.storeGoodsInfo.isShow,
                    orderIndex: this.storeGoodsInfo.orderIndex,
                    image: this.Images
                }
                // console.log('新增信息---',data)
				this.$api.addProductClass(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getClassify()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.loadingTJ = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                this.Images = "";
                this.storeGoodsInfo= {};
                this.popupType = '编辑';
				this.$api.getProductClassByID(e).then((res) => {
					if (res.state == 'success') {
						// console.log('更具id---',res.data)
                        this.storeGoodsInfo = res.data;
                        this.Images = res.data.image;
						this.dialogVisibleSwiper = true
					}else{
                        this.$message.error(res.message);
                    }
				})

			},
			// 编辑修改提交
			submitClick() {
                this.loadingXG = true;
                // let data = this.storeGoodsInfo
                let data={
                    className: this.storeGoodsInfo.className,
                    isShow: this.storeGoodsInfo.isShow,
                    orderIndex: this.storeGoodsInfo.orderIndex,
                    image: this.Images,
                    id: this.storeGoodsInfo.id
                }
				this.$api.updateProductClass(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.getClassify();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.loadingXG = false;
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该单位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delProductClassByID(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getClassify();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getClassify();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getClassify()
			},
		},




		created() {
			this.getClassify()

		}
	}
</script>

<style>

</style>
